module.exports = __webpack_public_path__ + "img/resized-cover9.f0b059e6.png";